export enum EmailVerificationErrorCodes {
    UserEmailVerificationTokenNotExist = "UserEmailVerificationTokenNotExist",
    UserEmailVerificationTokenAlreadyUsed = "UserEmailVerificationTokenAlreadyUsed",
    UserEmailVerificationTokenExpired = "UserEmailVerificationTokenExpired",
}
